import { render } from "./component-receiver-bank.vue?vue&type=template&id=31d012fd"
import script from "./component-receiver-bank.vue?vue&type=script&setup=true&lang=js"
export * from "./component-receiver-bank.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-receiver-bank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31d012fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31d012fd', __exports__)) {
    api.reload('31d012fd', __exports__)
  }
  
  module.hot.accept("./component-receiver-bank.vue?vue&type=template&id=31d012fd", () => {
    api.rerender('31d012fd', render)
  })

}


export default __exports__